import { render, staticRenderFns } from "./StartClaim.vue?vue&type=template&id=4210cad5&"
import script from "./StartClaim.vue?vue&type=script&lang=js&"
export * from "./StartClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports